import React from "react";
import PropTypes from "prop-types";
import TripSegmentHeader from "../TripSegmentHeader";
import TripSegmentList from "../TripSegmentList";

const propTypes = {
  tripSegments: PropTypes.array.isRequired,
  departureDateDisplay: PropTypes.string.isRequired
};

const TripBodyDetailed = ({ tripSegments, departureDateDisplay }) => {
  // For the header, we need to display where trip starts and ends.
  // For this we can search the first and last index of tripSegments to find
  // out the origin and conclusion of the trip.
  const {
    originAirportCity,
    originAirportState,
    originAirportCountry
  } = tripSegments[0]; // First trip
  const {
    destinationAirportCity,
    destinationAirportState,
    destinationAirportCountry
  } = tripSegments[tripSegments.length - 1]; // Last trip

  return (
    <div>
      <TripSegmentHeader
        {...{
          departureDateDisplay,
          originAirportCity,
          originAirportState: originAirportState
            ? originAirportState
            : originAirportCountry, // For international flights, PPN doesn't provide states. So we use the country in place of states
          destinationAirportCity,
          destinationAirportState: destinationAirportState
          ? destinationAirportState
          : destinationAirportCountry // For international flights, PPN doesn't provide states. So we use the country in place of states
        }}
      />
      <TripSegmentList tripSegments={tripSegments} />
    </div>
  );
};

TripBodyDetailed.propTypes = propTypes;

export default TripBodyDetailed;



// WEBPACK FOOTER //
// ./src/components/TripBodyDetailed/index.js